// src/ecrans/accueil/CartePliee.jsx — une carte de l'Accueil NEST (maquette
// v819) : en-tête (titre, sous-titre, lien à droite) et son contenu.
//
// AU TÉLÉPHONE (`plie` fourni), la carte se montre REFERMÉE : son titre, son
// chiffre et une ligne de résumé ; la toucher l'ouvre en entier, avec
// « Replier ». L'écran n'en ouvre qu'une à la fois (état tenu par
// EcranAccueil). À l'ordinateur, la carte est toujours ouverte.

import { IcBulle } from "./accueil-style";

/** La carte ouverte : en-tête et contenu. */
export function Carte({ titre, sous, action, onReplier, className = "", testId, children }) {
  return (
    <section className={`nacc-carte ${className}`.trim()} data-testid={testId}>
      <header className="nacc-hd">
        <div style={{ minWidth: 0 }}>
          <h3>{titre}</h3>
          {sous ? <p>{sous}</p> : null}
        </div>
        <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
          {action || null}
          {onReplier ? (
            <button type="button" className="nacc-replier" onClick={onReplier} data-testid={testId ? `${testId}-replier` : undefined}>
              Replier
            </button>
          ) : null}
        </span>
      </header>
      {children}
    </section>
  );
}

/**
 * La carte refermée du téléphone. `resume` : ce qu'elle montre fermée (le
 * chiffre, une ligne). `ic` : l'icône de l'en-tête. `sombre` : la carte de
 * l'argent (vert nuit).
 */
export function CarteRefermee({ titre, ic, resume, onOuvrir, sombre, testId }) {
  return (
    <button
      type="button"
      className={`nacc-pli${sombre ? " arg" : ""}`}
      onClick={onOuvrir}
      aria-expanded="false"
      data-testid={testId}
    >
      <span className="nacc-pli-h">
        {ic ? <IcBulle ic={ic} petite /> : null}
        <b>{titre}</b>
        <span className="nacc-pli-c" aria-hidden="true">›</span>
      </span>
      {resume}
    </button>
  );
}

/**
 * Le choix entre les deux : `plie` = { ouverte, onOuvrir, onReplier } au
 * téléphone, null à l'ordinateur.
 */
export default function CartePliee({ plie, titre, ic, resume, sombre, testId, children }) {
  if (plie && !plie.ouverte)
    return <CarteRefermee titre={titre} ic={ic} resume={resume} onOuvrir={plie.onOuvrir} sombre={sombre} testId={testId ? `${testId}-pliee` : undefined} />;
  return children(plie ? plie.onReplier : null);
}
